import { takeLatest, call, put, all } from "redux-saga/effects";
import * as types from "./types";
import { setApikeysData } from "./actions";
import api from "app/services/api";
import objectToQueryString from "app/utils/objectToQueryString";

export function* read({ payload }) {
  try {
    yield put({
      type: types.READ,
    });
    const { data } = yield call(
      api.get,
      `/apikeys${objectToQueryString(payload)}`
    );

    yield put(setApikeysData(data));
    yield put({
      type: types.READ_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: types.READ_FAIL,
    });
  }
}

export default all([takeLatest(types.REQUEST_READ, read)]);
